import React, { useState, useEffect, useContext, useRef } from 'react';
import Footer from '../../layout/footer/footer'
import '../home.css'
import { Accordion, Form, Col } from 'react-bootstrap';
import Editor from '../image/editor';
import EditorLogo from '../image/editor-logo';
import Select, { components } from 'react-select';
import { useCart } from '../../contexts/CartContext';
import DesignCard from "../../assets/images/design-card.png";
import Color from '../../assets/icons/color.svg'
import { Sidebar } from 'primereact/sidebar';
import Beard from '../../assets/images/logo-beard2.svg';

import Basket from '../../assets/icons/basket.svg'
import ArrowDown from '../../assets/icons/select-arrow-down.svg'

import beard from '../../assets/images/logo-beard.svg'
import Patter1 from '../../assets/images/design/patterns/1.svg'
import Patter2 from '../../assets/images/design/patterns/2.svg'
import Patter3 from '../../assets/images/design/patterns/3.svg'
import Patter4 from '../../assets/images/design/patterns/4.svg'

// Primary patterns
import PrimaryPatter1 from '../../assets/images/design/patterns/main/1.png'
import PrimaryPatter2 from '../../assets/images/design/patterns/main/2.png'
import PrimaryPatter3 from '../../assets/images/design/patterns/main/3.png'
import PrimaryPatter4 from '../../assets/images/design/patterns/main/4.png'


import ImageDefaultBg from '../../assets/images/design/image-default-bg.svg'
import LogoDefaultBg from '../../assets/images/design/logo-default-bg.svg'
import { useNavigate } from 'react-router-dom';


import DesignEditor from '../../components/design/component-design'

function DesignPage() {
  const navigate = useNavigate();

  // editor 
  const prepeardTexts = [
    "آرزوی بهترین هارو برایت دارم",
    "آمدی تا زمینم را آسمان کنی",
    "آیینه ی تمام نمای عشق، روزت مبارک",
    "با آرزوی اقبالی خوش",
    "با آرزوی بهترین موفقیت ها",
    "با تشکر از زحمات شما",
    "با نوید سلامتی و آرزوی تندرستی",
    "بماند به یادگار، به طراوت و به سادگی",
    "پدرم تولدت مبارک",
    "پدرم روزت مبارک",
    "پیوندتان مبارک ",
    "تبریک دست خالی مارا با سخاوت بی حدت بپذیر",
    "تقدیم برای سپاس از زحمات بی دریغ شما",
    "تقدیم به آنی که بهشت زیر پایش جای دارد",
    "تقدیم به زیباترین هدیه خداوند بر روی زمین",
    "تقدیم به مرد تمام روزهای زندگیم",
    "تقدیم به وجود پر مهرت",
    "تولدت مبارک",
    "تویی آن که خیزد از وی همه خرمی و سبزی ",
    "جهان کوچک من از تو زیباست",
    "ثانیه های زندگیت سرشار از شادی",
    "ثانیه ثانیه های زندگیتان سرشار از شادی",
    "دوستت دارم",
    "دیدگانت همیشه شاد",
    "حلول ماه مبارک رمضان مبارک",
    "دیدگانت همیشه شاد",
    "روز پاسدار مبارک ",
    "روز پدر بر شما مبارک باد",
    "روز پرستار مبارک",
    "روز پزشک مبارک",
    "روز جوان مبارک",
    "روز خبرنگار مبارک",
    "روز دانشجو مبارک",
    "روز دختر مبارک",
    "روز زن مبارک",
    "روز کارگر مبارک",
    "روز مادر بر شما مبارک باد",
    "روز مرد مبارک",
    "روز معلم مبارک",
    "عید سعید فطر مبارک",
    "مادرم تولدت مبارک",
    "مادرم روزت مبارک"
  ]
  const [text, setText] = useState();
  const [color, setColor] = useState('#000');
  const [font, setFont] = useState('shabnam');
  const [productId, setProductId] = useState(1);
  const [isAddBasket, setIsAddBasket] = useState(false);
  const [visiblePrepeardTexts, setVisiblePrepeardTexts] = useState(false);
  const [visibleFont, setVisibleFont] = useState(false);
  const [visibleSize, setVisibleSize] = useState(false);
  const [quantity, setQuantity] = useState(0);
  const [uniQueId, setUniQueId] = useState('');
  const [uniQueLogoId, setUniQueLogoId] = useState('');
  const [finalImage, setFinalImage] = useState(null);
  const colorInputRef = useRef(null);
  const { addToCart } = useCart();
  const [quantityLogo, setQuantityLogo] = useState(0);
  const [isAddLogoBasket, setIsAddLogoBasket] = useState(false);


  const handleIconClick = () => {
    if (colorInputRef.current) {
      colorInputRef.current.click();
    }
  };
  const [fonts, setFonts] = useState([{
    id: 'shabnam-medium',
    name: 'شبنم'
  },
  {
    id: 'IRANSans',
    name: 'ایران سنس'
  },
  {
    id: 'iran-yekan-medium',
    name: 'ایران یکان'
  }

  ]);
  const [size, setSize] = useState('20');
  const [sizes, setSizes] = useState([
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '20',
    '21',
    '22',
    '23',
    '24',
    '25',
    '26',
  ])
  // const getCategory = async () => {
  //   try {
  //     let res = await getCategories()
  //     setCategoryList(res.data.data)
  //   } catch (error) {
  const [image, setImage] = useState((ImageDefaultBg));
  const [logo, setLogo] = useState(null);
  let patterns = [
    { label: "Option 1", value: 1, icon: Patter1, primaryIcon: PrimaryPatter1 },
    { label: "Option 2", value: 2, icon: Patter2, primaryIcon: PrimaryPatter2 },
    { label: "Option 3", value: 3, icon: Patter3, primaryIcon: PrimaryPatter3 },
    { label: "Option 4", value: 4, icon: Patter4, primaryIcon: PrimaryPatter4 },
  ];
  const [pattern, setPattern] = useState(patterns[0]);
  const selectImage = (e) => {
    if (e.target.files[0]) {
      setImage(e.target.files[0]);
    }
    let element = document.getElementById('choose-file')
    if (element) {
      element.value = null;
    }
  };
  const resetImage = () => {
    let value = designType;
    if (value === 'picture') {
      setImage(ImageDefaultBg);
    }
    else {
      setImage(LogoDefaultBg);
    }
  };

  const selectLogo = (e) => {
    if (!image) {
      return;
    }
    if (e.target.files[0]) {
      setLogo(e.target.files[0]);
    }
    let element = document.getElementById('choose-logo');
    if (element) {
      element.value = null;
    }
  };
  const resetLogo = () => {
    setLogo(null);
  };


  const generateRandomId = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = (Math.random() * 16) | 0;
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  };
  const saveToLocalStorage = (updatedQuantity, uniQue) => {
    let settings = localStorage.getItem('settings');
    const newProductData = {
      id: uniQue,
      productId: productId,
      name: 'کارت دلخواه',
      imageBase64: finalImage,
      count: updatedQuantity,
      fontSize: size,
      font: typeof font === 'object' && Object.keys(font).length > 0 ? font.id : font,
      price: JSON.parse(settings)?.customCardPrice,
      fontColor: color,
      cardText: text,
    };

    // Retrieve current cart items or set an empty array if none
    const cartItems = JSON.parse(sessionStorage.getItem('cartItems')) || [];

    // Check if an identical product exists in the cart
    const existingProductIndex = cartItems.findIndex(item =>
      item.productId === productId &&
      item.font === newProductData.font &&
      item.fontSize === newProductData.fontSize &&
      item.fontColor === newProductData.fontColor &&
      item.cardText === newProductData.cardText &&
      item.price === newProductData.price &&
      item.id === newProductData.id
    );
    if (existingProductIndex >= 0) {
      // If product exists, update its quantity
      cartItems[existingProductIndex].count = updatedQuantity;
    } else {
      // If product is new, add it to the cart
      cartItems.push(newProductData);
    }
    // Remove 'id' from newProductData before saving to localStorage

    sessionStorage.setItem('cartItems', JSON.stringify(cartItems));
    addToCart();
  };

  const changeQuantity = (action) => {
    if (action === 'add') {
      setQuantity(prevQuantity => {
        const updatedQuantity = prevQuantity + 1;
        saveToLocalStorage(updatedQuantity, uniQueId); // Save with new quantity
        return updatedQuantity;
      });
    }
    if (action === 'minus') {
      if (quantity > 1) {
        setQuantity(prevQuantity => {
          const updatedQuantity = prevQuantity - 1;
          saveToLocalStorage(updatedQuantity, uniQueId); // Save with updated quantity
          return updatedQuantity;
        });
      } else {
        setIsAddBasket(false);
        removeFromCart(uniQueId); // Remove item if quantity is zero
        addToCart()
      }
    }
  };

  const handleAddToBasket = () => {
    const uniqueId = generateRandomId(); // Generate random ID for the item
    setUniQueId(uniqueId);
    setIsAddBasket(true);
    saveToLocalStorage(quantity > 0 ? quantity : 1, uniqueId); // Save product to cart with quantity
    setQuantity(quantity > 0 ? quantity : 1);
  };

  const changeLogoQuantity = (action) => {
    if (action === 'add') {
      setQuantityLogo(prevQuantity => {
        const updatedQuantity = prevQuantity + 1;
        saveToLocalStorage(updatedQuantity, uniQueLogoId); // ذخیره با مقدار جدید
        return updatedQuantity;
      });
    }
    if (action === 'minus') {
      if (quantityLogo > 1) {
        setQuantityLogo(prevQuantity => {
          const updatedQuantity = prevQuantity - 1;
          saveToLocalStorage(updatedQuantity, uniQueLogoId); // ذخیره با مقدار جدید
          return updatedQuantity;
        });
      } else {
        setIsAddLogoBasket(false);
        removeFromCart(uniQueLogoId); // حذف آیتم اگر تعداد صفر شود
        addToCart();
      }
    }
  };

  const handleAddLogoToBasket = () => {
    const uniqueId = generateRandomId(); // Generate random ID for the item

    setUniQueLogoId(uniqueId)
    setIsAddLogoBasket(true);
    saveToLocalStorage(quantityLogo > 0 ? quantityLogo : 1, uniqueId); // ذخیره کارت با مقدار
    setQuantityLogo(quantityLogo > 0 ? quantityLogo : 1);
  };
  // Helper function to remove product from cart
  const removeFromCart = (uniqueId) => {
    const cartItems = JSON.parse(sessionStorage.getItem('cartItems')) || [];

    // Filter out the specific item that matches all properties
    const updatedCart = cartItems.filter(item =>
      item.id !== uniqueId
      // !(
      //   item.productId === productId &&
      //   item.font === (typeof font === 'object' && Object.keys(font).length > 0 ? font.id : font) &&
      //   item.fontSize === size &&
      //   item.fontColor === color &&
      //   item.cardText === text &&
      //   item.price === JSON.parse(localStorage.getItem('settings'))?.customCardPrice
      // )
    );

    // Update localStorage with the filtered cart
    sessionStorage.setItem('cartItems', JSON.stringify(updatedCart));
  };

  const handleImageUpdate = (imageData) => {
    setFinalImage(imageData); // ذخیره‌ی تصویر نهایی در استیت
  };

  const [uploadedImage, setUploadedImage] = useState(null);
  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setUploadedImage(file);
    }
  };




  // Design
  const [designType, setDesignType] = useState('picture');
  const changeDesignType = (e) => {
    let value = e.target.id;
    setDesignType(value);
    if (value === 'picture') {
      setImage(ImageDefaultBg);
    }
    else {
      setImage(LogoDefaultBg);
    }
  };

  const goToBasket = () => {
    navigate('/shopping-cart');
  };
  const addNewDesign = () => {
    setUniQueId(generateRandomId());
    setIsAddBasket(false);
    setQuantity(1);
  };

  const addNewDesignLogo = () => {
    setUniQueLogoId(generateRandomId());
    setIsAddLogoBasket(false);
    setQuantityLogo(1);
  };
  function convertToPersianNumbers(input) {
    const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
    return input.replace(/\d/g, (digit) => persianDigits[digit]);
  }
  return (
    <div className='home-container'>
      <div className="container">
        <div className="d-flex align-items-center title gap-3">
          <img src={Beard} alt="Logo" />
          کادونا با تصویر دلخواه
        </div>
      </div>


      <div className="pb-20">
        <div className="container">
          <DesignEditor />
          <div className="design-description bg-white rounded-2xl mt-5 ">
            <div className="flex align-items-center justify-between decription-card">
              <img className='icon-bird' src={require('../../assets/images/bird.svg').default} alt="" />
              <div>
                <h2 className="font-bold text-blue">
                  قوانین درخواست کادونا با متن و تصویر اختصاصی
                </h2>
              </div>
              <img className='icon-bird reverse' src={require('../../assets/images/bird.svg').default} alt="" />
            </div>
            <div className="mt-4 ">
              <ul className='font-bold p-0'>
                <li className='text-justify'>
                  {
                    convertToPersianNumbers('متن و تصویر درخواستی بر روی کارت هدیه می‌بایست واضح و منطبق با معیارهای جامعه ایرانی اسلامی بوده، تصویر شخصی افراد باید با پوشش منطبق بر معیارهای جامعه ایرانی اسلامی باشد. متاسفانه به دستور مراجع مربوطه، از پذیرفتن تصاویر بدون پوشش اسلامی معذوریم.')
                  }
                </li>
                <li className='text-justify'>
                  {
                    convertToPersianNumbers('تصویر ارسالی می‌بایست حداقل در ابعاد 8.5 * 5.5 سانتی‌متر یا 1004 در 650 پیکسل و 150dpi بوده و یا این نسبت را رعایت نمایند تا کادر نمونه به درستی پوشش داده شود. می توانید اندازه و جانمایی تصویر را تنظیم نمایید. دقت کنید که در زمینه تصویر روی کارت حاشیه سفید وجود نداشته باشد.')
                  }
                </li>
                <li className='text-justify'>
                  {
                    convertToPersianNumbers('در صورت انتخاب متن یا طرح مرتبط با معرفی شرکت، سازمان یا محصول، ابتدا متن و طرح ثبت شده، مورد بررسی قرار گرفته و در صورت تأیید، چاپ کارت انجام خواهد پذیرفت. در صورت عدم تایید، موارد جهت اصلاح با پیامک به اطلاع شما خواهد رسید و شما می توانید با مراجعه به «پانل کاربری»  «کارت‌های خریداری شده» نسبت به ویرایش و ارسال مجدد کارت اقدام نمایید')
                  }
                  </li>
                <li className='text-justify'>
                  {
                    convertToPersianNumbers('تصاویر با همان کیفیتی که ارسال می شوند چاپ خواهند شد. تصاویر اسکن شده، عکسهایی که با دوربین موبایل معمولی گرفته می شوند، تصاویر با dpi کمتر از 150، عکسهایی که با لرزش دوربین گرفته شده اند، تصاویری که نورپردازی مناسب ندارند، و بطور کلی تصاویر با کیفیت پایین، به هنگام چاپ کیفیت و شفافیت مناسب را نخواهند داشت. پیش از ارسال تصویر از کیفیت و شفافیت آن مطمئن شوید.')
                  }
                  </li>
                <div className="mt-5">
                  <h6 className='text-blue font-bold'>نکات مهم در تایید و رد درخواست‌ها:</h6>
                </div>
                <li className='text-justify'>تصویر ارسالی به‌صورت افقی (landscape) آپلود شود.</li>
                <li className='text-justify'>لطفاً به محل قرار گیری لوگوها و شماره کارت بر روی تصویر دقت فرمایید، به گونه ای که طرح شما مانع خوانا بودن اطلاعات کارت نباشد.</li>
                <li className='text-justify'>از درج تصاویر دارای حق نشر و بدون اجازه صاحب اثر خودداری فرمایید.</li>
                <li className='text-justify'>امکان درج آدرس سایت، شماره تلفن و شماره حساب بر روی کارت بدون اخذ مجوز وجود ندارد. در صورت نیاز به این امکان لطفا با شماره تلفنهای کارت هدیه کادونا تماس بگیرید.</li>
                <li className='text-justify'>تصاویری که رنگ زمینه آنها شماره کارت یا لوگوهای درج شده بر روی کارت را مخدوش یا ناخوانا می سازد، مورد تاًیید قرار نمی‌گیرد.</li>
                <li className='text-justify'>نام یا تصاویر اشخاص شناخته شده، مقامات سیاسی، بازیگران و هنرمندان پذیرفته نمی شود.</li>
                <li className='text-justify'>متون حاوی مضامین افترا، توهین، خشونت و نژادپرستانه پذیرفته نمی شود.</li>
                <li className='text-justify'>متون یا تصاویری که به هر نحوی ناقض قوانین و مقررات جاری کشور باشد تأیید نخواهد شد.</li>
              </ul>
              <div className='font-bold mt-5 px-2'>
                <span className='text-[#E14942]'>
                  توجه:
                </span>
                <p className=' number text-justify'>
                  {
                    convertToPersianNumbers('امکان صدور کادونا با لوگوی مشتری در تیراژ بالاتر و بدون محدودیت تعداد و سقف مبلغ شارژ برای سازمانها و ارگانها و سایر اشخاص حقوقی وجود دارد. برای سفارش کارت هدیه اشخاص حقوقی با شماره تلفن 92001608-021 تماس حاصل فرمایید.')
                  }
                </p>
              </div>
            </div>
          </div>
        </div>

      </div >

      <div className="home-footer mt-40">
        <Footer />
      </div>
    </div >
  );
}

export default DesignPage;
